<template>
  <v-row>
    <v-col>
      <MiniMetricTile color="blue" :loading="loading">
        <template #icon>
          {{ categoryIcon }}
        </template>
        <template #metric>
          {{ data?.total || 0 }}
        </template>
        <template #title>
          {{ categoryTitle }}
        </template>
      </MiniMetricTile>
    </v-col>
    <v-col>
      <MiniMetricTile color="green" :loading="loading" text-color="green">
        <template #icon>
          fa fa-check
        </template>
        <template #metric>
          {{ data?.completed || 0 }}
        </template>
        <template #title>
          {{ completedLabel }}
        </template>
      </MiniMetricTile>
    </v-col>
    <v-col>
      <MiniMetricTile color="red" :loading="loading" text-color="red">
        <template #icon>
          fa fa-x
        </template>
        <template #metric>
          {{ data?.pending || 0 }}
        </template>
        <template #title>
          {{ pendingLabel }}
        </template>
      </MiniMetricTile>
    </v-col>
    <v-col>
      <MiniMetricTile color="blue" :loading="loading" :progress-bar-value="data?.completed ? data?.percentage : 0">
        <template #icon>
          fa fa-bar-chart
        </template>
        <template #metric>
          {{ data?.completed ? data?.percentage : 0 }}%
        </template>
        <template #title>
          {{ percentageLabel }}
        </template>
        <template #comment>
          {{ data?.completed }} Completions / {{ data?.total || 0 }} Registered Users
        </template>
      </MiniMetricTile>
    </v-col>
    <v-col v-if="adoptionTotal">
      <MiniMetricTile color="pink" :loading="loading" :progress-bar-value="data?.completed ? data?.percentage : 0">
        <template #icon>
          fa fa-bar-chart
        </template>
        <template #metric>
          {{ adoptionPercentage }}%
        </template>
        <template #title>
          Adoption
        </template>
        <template #comment>
          {{ data.completed }} Completions / {{ adoptionTotal }} Issued Licenses
        </template>
      </MiniMetricTile>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";

const props = defineProps({
  categoryIcon: {
    type: String,
    default: "fa fa-chart-bar"
  },
  categoryTitle: {
    type: String,
    default: "Usage Summary"
  },
  percentageLabel: {
    type: String,
    default: "Usage Rate"
  },
  completedLabel: {
    type: String,
    default: "Completed"
  },
  pendingLabel: {
    type: String,
    default: "Pending"
  },
  data: {
    type: Object,
    required: true
  },
  adoptionTotal: {
    type: Number,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
});

const adoptionPercentage = props.adoptionTotal && props.adoptionTotal > 0 && props.data?.completed
  ? Math.round((props.data.completed / props.adoptionTotal) * 100)
  : 0;
</script>
